<template>
    <modal
        :title="title"
        :id="id"
        :actionButtons="true"
        :size="'full'"
        @shown="shown"
        @hidden="hidden"
    >
        <div class="card d-md-none">
            <div class="ml-4">
                <ul class="nav nav-tabs nav-overflow">
                    <li class="nav-item">
                        <a
                            href="#"
                            class="nav-link text-center"
                            :class="{active:tab === 'MAP'}"
                            @click.prevent="tab='MAP'"
                        >{{ $t('Map') }}</a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="#"
                            class="nav-link text-center"
                            :class="{active:tab === 'SERVICES'}"
                            @click.prevent="tab='SERVICES'"
                        >{{ $t('Services') }}</a>
                    </li>
                    <li class="nav-item">
                        <a
                            href="#"
                            class="nav-link text-center"
                            :class="{active:tab === 'TOTAL'}"
                            @click.prevent="tab='TOTAL'"
                        >{{ $t('Total') }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row mt-0">
            <div class="col-12 col-md-7 col-lg-8 fullHeight">
                <div class="card d-md-block" v-show="tab === 'MAP'">
                    <div class="card-body pt-0 m-0">
                        <div class="row mt-3">
                            <div class="col"></div>
                            <div class="col-auto">
                                <custom-switch v-model="kid" :title="$t('Baby map') " id="kidOrNot2" class="m-0 p-0" />
                            </div>
                        </div>

                        <image-map :kid="kid" :selectable="true" v-model="selected" :width="15" :tooths="{}"></image-map>

                        <div class="row mt-2 mb-0">
                            <div class="col">
                                <custom-switch
                                    v-if="selected.length>1"
                                    v-model="grouped"
                                    id="grouped"
                                    :title="$t('Grouped')"
                                ></custom-switch>
                            </div>
                            <div class="col-auto">
                                <button
                                    v-if="selected.length<1"
                                    disabled
                                    class="btn btn-outline-info btn-sm"
                                >{{ $t('Teeth not selected') }}
                                </button>
                                <button class="btn btn-outline-info btn-sm" @click="selected=[]" v-else>
                                    <i class="fe fe-x"/>
                                    {{ $t('Clear selection') }}
                                    <span
                                        class="small"
                                    >({{ selected.length }})</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <preset-treatment-browser class="d-md-block calcHeight col-12" v-show="tab === 'SERVICES'" :use-preset="usePreset" :use-treatment="addToCart"></preset-treatment-browser>
            </div>
            <div v-show="tab === 'TOTAL'" class="col-12 col-md-5 col-lg-4 d-md-block">
                <div class="relative d-flex flex-md-column flex-column-reverse">
                    <div
                        class="sticky-top fit-tablet"
                        :style="{ height: [ !isNoteEditing ? 'calc(var(--calculated-vh, 1vh) * 100 - 270px)' : 'calc(var(--calculated-vh, 1vh) * 100 - 487px)' ] }"
                    >
                        <div class="card mb-2" v-if="cart.length == 0">
                            <div class="card-body text-center text-muted small">
                                <div class="h1 mt-0 p-2 fe fe-shopping-cart"></div>
                                {{ $t('Nothing yet') }}
                            </div>
                        </div>
                        <div class="card mb-2" v-for="(cartItem, index) in cart" :key="index">
                            <div class="card-body p-2">
                                <div class="row align-items-center">
                                    <div class="col small">
                                        {{ cartItem.item.label }}
                                        <div>
                                            <money :value="(cartItem.item.price || 0)*cartItem.quantity" class="small text-muted"/>
                                        </div>
                                    </div>
                                    <div class="col-auto p-0 small">
                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <button class="btn btn-white btn-sm" @click="changeCartQuantity(index, -1)">-</button>
                                            <button class="btn btn-white btn-sm">{{ cartItem.quantity }}</button>
                                            <button class="btn btn-white btn-sm" @click="changeCartQuantity(index, 1)">+</button>
                                        </div>
                                    </div>

                                    <div class="col-auto small">
                                        <button
                                            class="btn btn-white btn-sm"
                                            :id="`service-${cartItem._id}`"
                                            :title="$t('Select tooth')"
                                            v-b-tooltip.hover
                                        >{{ cartItem.tooths.length }}
                                        </button>
                                        <tooth-popover v-model="cartItem.tooths" :target="'service-' + cartItem._id" :isKid="kid" />
                                        <button class="btn btn-white btn-sm border-0" @click="removeFromCart(index)">
                                            <i class="fe fe-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="mt-auto mb-md-auto mb-3">
                        <div class="card p-3 m-0 mb-3">
                            <notes-widget
                                :customerId="customerId"
                                :tooth="selected"
                                @isNoteEditMode="isNoteEditMode"
                            />
                        </div>
                        <div class="card p-3 m-0">
                            <span class="text-muted small">{{ $t('Total') }}:</span>
                            <money class="h2 m-0" :value="total"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template slot="modal-header">
            <span></span>
        </template>
        <template slot="modal-footer">
            <div class="card-footer" style="display:block">
                <div class="row">
                    <div class="col" style="position: initial;">
                        <div v-if="tab !== 'TOTAL'" class="d-md-none d-block position-absolute" style="left: 10px;">
                            <span class="text-muted small">{{ $t('Total') }} ({{ cardTotalServices(cart) }}): </span>
                            <br>
                            <money class="text-muted small" :value="total"/>
                        </div>
                    </div>
                    <div class="col-auto"></div>
                    <div class="col-auto">
                        <button type="button" @click="close" class="mr-2 btn btn-white">{{ $t('Cancel') }}</button>
                        <button type="button" @click="confirmed" class="btn btn-primary mr-2" :disabled="areNextButtonsDisabled">{{ $t('Complete') }}</button>
                        <button type="button" @click="saveAndNext" class="btn btn-secondary" :disabled="areNextButtonsDisabled" v-if="$settings.useExtendedWorkOrder">{{ $t('Next') }}</button>
                    </div>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
import Money from "@/components/Money.vue";
import ImageMap from '@/components/Teeth/Map';
import CustomSwitch from '@/components/CustomSwitch';
import ToothPopover from '@/components/Tooth/ToothPopover'
import SpecialtyNav from '@/components/SpecialtyNav'
import { mapActions, mapGetters, mapState } from "vuex";
import { modalMixins } from "@/mixins/modal.js";
import PresetTreatmentBrowser from "@/components/PresetTreatmentBrowser";
import NotesWidget from '@/Pages/People/Customer/NotesWidget.vue'

export default {
    name: "ExpressCheckoutModal",
    props: ["id", "customerId"],
    mixins: [modalMixins],
    components: {
        PresetTreatmentBrowser,
        Modal,
        Money,
        ImageMap,
        SpecialtyNav,
        CustomSwitch,
        ToothPopover,
        NotesWidget
    },
    data() {
        return {
            tab: 'MAP',
            total: 0,
            cart: [],
            grouped: false,
            selected: [],
            title: this.$t("Work order"),
            kid: false,
            resultExams: [],
            usedPresets: {},
            isNoteEditing: false,
        };
    },
    computed: {
        ...mapState('exam', { isCreating: 'isCreatePending' }),
        areNextButtonsDisabled() {
            return this.isCreating || this.cart.length === 0;
        },
    },
    watch: {
        cart: {
            handler(newVal) {
                this.total = newVal.reduce((total, item) => total + item.quantity * (item.price || 0), 0);
            },
            deep: true
        }
    },
    methods: {
        ...mapActions('presets', { fetchPresets: 'find', createPreset: 'create', getPreset: 'get', }),
        ...mapActions('cart', { reallyAddToCart: 'create', removeFromCart: 'remove' }),
        ...mapActions('exam', { createExam: 'create' }),

        isNoteEditMode(val) {
            this.isNoteEditing = val
        },

        shown() {
            const { Cart } = this.$FeathersVuex;
            let data = Cart.getFromStore('temp');
            if (data) {
                delete data._id;
                let model = this.$copy(data).model
                this.cart = model.carts || []
                new Cart({
                    _id: 'temp',
                    model: {}
                });
            }
            this.fetchPresets(this.presetParams);
        },

        hidden() {
            this.cart = []
            this.selected=[]
        },


        usePreset(preset) {
            preset.treatments.forEach(cart => {
                this.addToCart(cart, preset._id);
            });

            if (this.selected.length)
                this.selected.forEach(tooth => this.usedPresets[tooth] = [...this.usedPresets[tooth] || [], preset]);
            else
                this.usedPresets[null] = [...this.usedPresets[null] || [], preset];
        },

        addToCart(item, presetId) {
            let quantity = 1;
            if (!this.grouped && this.selected.length > 1) {
                quantity = this.selected.length;
            }
            let _id = item._id;
            let tooths = this.$unique(this.selected);

            let index = this.cart.findIndex(i => {
                return _id == i._id;
            });
            let price = item.price;

            if (index >= 0) {
                this.cart[index].quantity = this.cart[index].quantity + quantity;
                this.cart[index].tooths.push(...tooths);
                this.cart[index].tooths = this.$unique(this.cart[index].tooths);
            } else {
                this.cart.push({ _id, item, quantity, tooths, price, grouped: this.grouped, presetId: presetId });
            }
        },

        removeFromCart(idx) {
            this.cart.splice(idx, 1);
        },

        changeCartQuantity(idx, quantity) {
            this.cart[idx].quantity = this.cart[idx].quantity + quantity;
            if (this.cart[idx].quantity <= 0) {
                this.removeFromCart(idx);
            }
        },

        async confirmed() {
            let exams = {}
            this.cart.forEach(cart => {
                const examTreatment = { ...cart.item, done: true, doneAt: new Date() }
                if (cart.tooths.length) {
                    cart.tooths.forEach(tooth => {
                        exams[tooth] = [...exams[tooth] || [], examTreatment]
                    })
                } else {
                    exams[null] = [...exams[null] || [], examTreatment]
                }

                this.reallyAddToCart({
                    customerId: this.customerId,
                    grouped: cart.grouped,
                    tooths: cart.tooths,
                    treatments: cart.item,
                    quantity: cart.quantity,
                    presetId: cart.presetId
                }).catch(e => {
                    console.log('e', e);
                });
            });
            this.resultExams = await Promise.all(
                Object.entries(exams).map(([tooth, treatments]) => {
                    const presets = this.usedPresets[tooth];
                    const exam = {
                        tooth: tooth === 'null' ? null : tooth,
                        treatments,
                        customerId: this.customerId,
                        odb: [],
                        cdb: [],
                        diagnosisFinal: [],
                        reviewed: !this.$settings.useExtendedWorkOrder,
                    }
                    if (presets) {
                        presets.forEach(preset => {
                            exam.odb.push(...preset.odb);
                            exam.cdb.push(...preset.cdb);
                            exam.diagnosisFinal.push(...preset.icdFinal);
                        });
                    }
                    return this.createExam(exam)
                })
            )

            this.$root.$emit('work-order-confirmed', this.cart);
            this.$root.$emit("bv::hide::modal", this.id);
        },

        async saveAndNext() {
            await this.confirmed()

            const { Treatment } = this.$FeathersVuex;
            new Treatment({
                _id: 'temp',
                data: {
                    cart: this.cart,
                    kid: this.kid,
                    selected: this.selected,
                    resultExams: this.resultExams,
                }
            })

            this.openModal({
                id: 'examModalNew'
            })
        },

        validation(field) {
            if (this.errors && this.errors[field]) return false;
            else return null;
        },

        close() {
            this.$root.$emit("bv::hide::modal", this.id);
        },

        cardTotalServices(cart) {
            return cart.reduce((total, item) => total + item.quantity, 0);
        }
    }
};
</script>

<style lang="scss">

@media only screen and (min-width: 767px) {
    .sticky-top.fit-tablet {
        position: relative !important;
        //height: calc(var(--calculated-vh, 1vh) * 100 - 250px);
        overflow: hidden;
        overflow-y: auto;
    }
    .fullHeight {
        height: calc(var(--calculated-vh, 1vh) * 100 - 130px);
    }
    .calcHeight {
        height: calc(var(--calculated-vh, 1vh) * 100 - 400px)!important;
        overflow-x: auto;
    }
}

@media only screen and (max-width: 767px) {

    .sticky-top.fit-tablet {
        height: calc(var(--calculated-vh, 1vh) * 100 - 270px);
        overflow: hidden;
        overflow-y: auto;
    }
    .fullHeight {
        height: auto;
    }
    .calcHeight {
        height: calc(var(--calculated-vh, 1vh) * 100 - 200px)!important;
        overflow-x: auto;
    }
    .modal-full .modal-content {
        height: inherit !important;
    }
    .popover {
        width: 300px!important;
    }
    .modal-body {
        padding: 1rem;
    }
}

</style>
